import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";

const encodedUrlParamsToken = "encodedUrlParamsToken";

@Injectable({ providedIn: "root" })
export class UrlParamsService {
  private cryptoSecretKey = "hjsjhb87asjhajscjhb";
  /**
   * Sets url router params id or object.
   * @param urlRouterParams which is the urlRouterParams pass from one router to another.
   */
  set encodedUrlRouterParams(urlRouterParams) {
    if (urlRouterParams) {
      //  localStorage.setItem(encodedUrlParamsToken, urlRouterParams);
      this.encryptUrlRouterParamsData(urlRouterParams);
    } else {
      localStorage.removeItem(encodedUrlParamsToken);
    }
  }

  get encodedUrlRouterParams() {
    return this.decryptUrlRouterParamsData();
  }

 get encryptTextData() {
  let encrypt = this.encryptTestData('welcome');
  console.log('Encrypted Data',encrypt);
  return encrypt;
 }
  encryptTestData(txt){
    return CryptoJS.AES.encrypt(txt, this.cryptoSecretKey).toString();
  }
  decryptTestData (encrypted) {
    const decrypted = CryptoJS.AES.decrypt(encrypted, this.cryptoSecretKey);
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  encryptUrlRouterParamsData(urlRouterParamsData): void {
    const cipherTextUrlRouterParamsData = CryptoJS.AES.encrypt(
      JSON.stringify(urlRouterParamsData),
      this.cryptoSecretKey
    ).toString();
    localStorage.setItem(encodedUrlParamsToken, cipherTextUrlRouterParamsData);
  }

  decryptUrlRouterParamsData() {
    const bytes = CryptoJS.AES.decrypt(
      localStorage.getItem(encodedUrlParamsToken),
      this.cryptoSecretKey
    );
    if (bytes) var originalText = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(originalText);
  }
}
